import React from 'react';
import NoPermissionError from './NoPermissionError';

export default (props) => {
  const { title } = props;
  return (
    <NoPermissionError
      title={title}
      text={i18n('You are not allowed to view your own resource.')}
    />
  );
};
